import { defineMessages } from 'react-intl-next';

export default defineMessages({
    emptyStateDescription: {
        defaultMessage: 'There are no topics available, they may not have been created or have been hidden',
        description: 'Description message for topics empty state',
        id: 'hc.customization.list-of-topics.empty-state-description.non-final',
    },
});
